import {
  InAppNotificationId,
  InAppNotification,
  InAppNotificationStream,
  ProductType,
  ListNotificationsArgs,
  NotificationStatus,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function list(
  productType: ProductType,
  args: ListNotificationsArgs,
  status: NotificationStatus,
): Promise<InAppNotification[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/notifications/{product_type}/{status}`, {
    path: {product_type: productType, status},
    query: args,
  });
}

export async function channelStream(productType: ProductType): Promise<InAppNotificationStream> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/notifications/channel_stream/{product_type}`,
    {path: {product_type: productType}},
  );
}

export async function markAsRead(notification_ids: InAppNotificationId[]) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/notifications/mark_as_read`, {
    body: notification_ids,
  });
  await invalidateQueries([q.notifications.filter(), q.notificationStream.filter()]);
  return res;
}

export async function markAllRead(productType: ProductType) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/notifications/mark_all_read`, {
    body: productType,
  });
  await invalidateQueries([q.notifications.filter(), q.notificationStream.filter()]);
  return res;
}

export async function archive(notification_id: InAppNotificationId) {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/notifications/{user_notification_id}/archive`,
    {path: {user_notification_id: notification_id}},
  );
  await invalidateQueries([q.notifications.filter(), q.notificationStream.filter()]);
  return res;
}

export async function archiveAll() {
  const res = await platformedClient.internalRequest("delete", `/region/{region}/api/notifications/all`, {});
  await invalidateQueries([q.notifications.filter(), q.notificationStream.filter()]);
  return res;
}
